import messages from './cmsCopyUnitToLocale.json' with { type: 'json' };

export const cmsCopyUnitToLocaleEn: Readonly<typeof messages> = messages;
